import { useElementContext } from "../../../contexts";

const FormCheckboxField = (props) => {
  const {
    CommonModule: { FormCheckboxGroupField },
  } = useElementContext();
  return <FormCheckboxGroupField {...props} options={[{ value: !!props.value, name: props.attributeName }]} />;
};

export default FormCheckboxField;
